import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Breadcrumbs({ icon, title, route, light, homeRoute }) {
  const routes = route.slice(0, -1);

  return (
    <MDBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        <Link to={homeRoute || "/dashboard"}>
          <MDTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </MDTypography>
        </Link>
        {routes.map((el, index) => {
          // Define which segments should be entirely ignored in the breadcrumb trail
          const ignoredSegments = ["list", "add", "edit", "details"];
          if (ignoredSegments.includes(el.toLowerCase())) return null;

          // Define which segments should be visible but NOT clickable (container segments)
          const nonClickableSegments = ["claims", "lessons", "events", "green-school", "work-plan"];

          const mapping = {
            claims: "/claims/list",
            lessons: "/lessons/list",
            events: "/events/list",
            publications: "/publications/list",
            "green-school": "/green-school/add",
            "work-plan": "/work-plan/list",
            "leave-request": "/leave-list",
            user: "/user-list",
            "user-edit": "/user-list",
            "tickets-edit": "/tickets-list",
          };

          const getPath = () => {
            if (nonClickableSegments.includes(el.toLowerCase())) return null;
            if (mapping[el]) return mapping[el];
            if (["edit", "add", "details", "list"].includes(el) || !isNaN(el)) return null;
            return `/${route.slice(0, index + 1).join("/")}`;
          };

          const path = getPath();
          const content = (
            <MDTypography
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {el.replace("-", " ")}
            </MDTypography>
          );

          return path ? (
            <Link to={path} key={el}>
              {content}
            </Link>
          ) : (
            <span key={el} style={{ cursor: "default" }}>
              {content}
            </span>
          );
        })}
        <MDTypography
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {title.replace("-", " ")}
        </MDTypography>
      </MuiBreadcrumbs>
      {/* <MDTypography
        fontWeight="bold"
        textTransform="capitalize"
        variant="h6"
        color={light ? "white" : "dark"}
        noWrap
      >
        {title.replace("-", " ")}
      </MDTypography> */}
    </MDBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
  homeRoute: PropTypes.string,
};

export default Breadcrumbs;
